import { render, staticRenderFns } from "./FUmkmTypeTable.vue?vue&type=template&id=d667561e&scoped=true"
import script from "./FUmkmTypeTable.vue?vue&type=script&lang=js"
export * from "./FUmkmTypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d667561e",
  null
  
)

export default component.exports